import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { userManager } from "../auth-config";

export const CallbackPage = () => {
	const navigate = useNavigate();
	// The authorization code is single-use, so the exchange must happen exactly
	// once. StrictMode double-invokes effects in development, and the second
	// call fails against an already-consumed code — which would bounce us to
	// /login, where LoginPage immediately redirects back here, looping.
	const exchangeStarted = useRef(false);

	useEffect(() => {
		if (exchangeStarted.current) return;
		exchangeStarted.current = true;

		(async () => {
			try {
				await userManager.signinRedirectCallback();
				navigate("/");
			} catch (error) {
				console.error("Sign-in callback error:", error);
				navigate("/login");
			}
		})();
	}, [navigate]);

	return (
		<div className="min-h-screen flex items-center justify-center bg-[var(--color-bg-app)]">
			<div className="text-center">
				<div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--color-accent)] border-t-transparent mx-auto"></div>
				<p className="mt-4 text-[var(--color-text-secondary)]">
					Completing login...
				</p>
			</div>
		</div>
	);
};
